import { Box } from "@chakra-ui/react";

/**
 * @typedef {object} Props
 * @property {string} [maxWidth] css max-width property
 *
 * @param {import("react").PropsWithChildren<Props>} props
 */
function CenteredContent({ maxWidth = "1200px", children }) {
  return (
    <Box maxW={maxWidth} mx="auto">
      {children}
    </Box>
  );
}

export default CenteredContent;
